// src/states/form.state.ts
import { NotificationService } from '@/api/notification';
import { INotificationData } from '@/utils/types/notification';
import { create } from 'zustand';

interface FormState {
  notificationList: INotificationData[];
  setNotificationList: (list: INotificationData[]) => void;
  setNotifictionCount: (count: number) => void;
  notificationCount: number;
  fetchNotifications: (email: string) => Promise<void>;
}

const useNotificationState = create<FormState>(set => ({
  notificationList: [],
  notificationCount: 0,
  setNotificationList: (list: INotificationData[]) => set({ notificationList: list }),
  setNotifictionCount: (count: number) => set({ notificationCount: count }),
  fetchNotifications: async (email: string) => {
    const notifications = await NotificationService.fetchNotifications({
      page: 0,
      limit: 100,
      isRead: false,
      userId: email,
    });

    if (notifications) {
      set({ notificationList: notifications.content, notificationCount: notifications.totalElements });
    } else {
      set({ notificationList: [], notificationCount: 0 }); // Reset state if needed
    }
  },
}));

export default useNotificationState;
